import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import API from './API';

class ForgotPassword extends Component {
    state = {
        email: '',
        message: null,
        error: null,
        loading: false
    };

    handleChange = (e) => {
        this.setState({ email: e.target.value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true, message: null, error: null });

        try {
            await API.sendPasswordReset(this.state.email);
            this.setState({ message: 'パスワードリセットメールを送信しました。', loading: false });
        } catch (err) {
            console.log("ForgotPassword Error caught:", err);
            if (err.message === 'メールアドレスが間違っています') {
                this.setState({ error: 'メールアドレスが間違っています', loading: false });
            } else {
                console.log("Showing generic error or raw error for debug");
                this.setState({ error: `送信に失敗しました (${err.message})`, loading: false });
            }
        }
    };

    render() {
        const { email, message, error, loading } = this.state;

        return (
            <Container>
                <Row className="justify-content-md-center">
                    <Col md={6}>
                        <div className="page-wrapper" style={{ marginTop: '50px' }}>
                            <h2 className="text-center mb-4">パスワードをお忘れの方</h2>

                            {message && <Alert variant="success">{message}</Alert>}
                            {error && <Alert variant="danger">{error}</Alert>}

                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group controlId="email">
                                    <Form.Label>登録メールアドレス</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="example@email.com"
                                        value={email}
                                        onChange={this.handleChange}
                                        required
                                    />
                                    <Form.Text className="text-muted">
                                        パスワード再設定用のリンクを送信します。
                                    </Form.Text>
                                </Form.Group>

                                <Button variant="primary" type="submit" disabled={loading || !email} block>
                                    {loading ? '送信中...' : '送信'}
                                </Button>
                            </Form>

                            <div className="text-center mt-3">
                                <Link to="/login">ログイン画面に戻る</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ForgotPassword;
